export default {
  screens: [
    {
      type: 'intro',
      title: 'L’art du diadème',
      content:
        'Apothéose joaillière et symbole de la Maison, emblème de pouvoir et accessoire de mode, le diadème se décline du plus classique au plus extravagant.',
      idYt: '2YX1UzJIlp0',
      videoCover: 'world/diademe/video.jpg',
      desktop: {
        cover: 'world/diademe/cover-1.jpg'
      },
      mobile: {
        cover: 'world/diademe/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: 'auto',
          height: '65%',
          bottom: '-18%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      content:
        'Depuis 1780, la Maison a créé plus de 2000  diadèmes, bandeaux et aigrettes pour les monarchies et les grandes familles aristocratiques.<br/><br/> La vingtaine de diadèmes et les trois  cents modèles  en maillechort présentés dans l’exposition illustrent la créativité et la virtuosité de Chaumet.',
      isCover: true
    },
    {
      type: 'grid',
      videoBlock: {
        cover: 'world/diademe/video-diademe.jpg',
        idYt: 'IM2d5lCTqIA'
      },
      middleImg: 'world/diademe/gridMiddle.jpg',
      rightImg: 'world/diademe/gridRight.jpg',
      title: 'Le diadème Vertiges',
      content:
        'Créer le diadème du 21ème siècle, tel fut le défi lancé par Chaumet aux élèves de la Central Saint Martins.<br/><br/> En revisitant les jardins à la française, Scott Armstrong imagine le diadème Vertiges. Une réinvention du paysage Chaumet tout en courbes et lignes franches.'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/fr/worlds/diademe.js